import React from "react";
import { MdError } from "react-icons/md";
import { t } from "i18next";

const ErrorIcon = () => <MdError className="w-16 h-16 text-danger" />;

export const getErrorDialogProps = (props) => ({
  className: "border-t-4 border-danger-hover",
  titleClassName: "text-danger-hover",
  textClassName: "text-danger",
  image: props.image || <ErrorIcon />,
  buttons: props.buttons || [
    {
      text: t("general.buttons.confirm"),
      variant: "danger",
    },
  ],
  ...props,
});

export default ErrorIcon;